export const searchDefaults = {
    destinationLocationCode: "Barcelona_ES,Lisbon_PT",
    roomAllocation: "",
    searchType: {
        flightHotel: "FlightHotel",
        flightCar: "FlightCar"
    }    
};
